import { ContactsModuleRdfLib } from "./rdflib/ContactsModuleRdfLib.js";
export default ContactsModuleRdfLib;
//# sourceMappingURL=index.js.map